import axios from "axios";
const baseURL = process.env.REACT_APP_API_URL;
// Update theme
export const update_theme = async (theme_mode) => {
    const response = await axios.post(baseURL + "/update-theme",{
        theme_mode:theme_mode
    })
  return response.data;
}
// Update Admin theme
export const update_theme_admin = async (theme_mode) => {
  const response = await axios.post(baseURL + "/update-admin-theme",{
      theme_mode:theme_mode
  })
return response.data;
}